// Indonesian texts for Jobs, Settings, Login, URL explorer, batch pages and some shared components.
export default {
  // Jobs
  "All": "Semua",
  "In progress": "Sedang berjalan",
  "Completed": "Selesai",
  "Failed": "Gagal",
  "Recovery": "Pemulihan",
  "Analysis": "Analisis",
  "Quality check": "Pemeriksaan kualitas",
  "Visual check": "Pemeriksaan visual",
  "Deployment": "Deploy",
  "Files deleted": "File dihapus",
  "expires {when}": "kedaluwarsa {when}",
  "Jobs": "Proses",
  "Analyses and recoveries run on the server and continue when you close the browser.": "Analisis dan pemulihan berjalan di server dan tetap berlanjut saat browser ditutup.",
  "No jobs here": "Belum ada proses di sini",
  "Start by analyzing a domain on the Overview page.": "Mulai dengan menganalisis domain di halaman Ringkasan.",
  "Job": "Proses",
  "Domain": "Domain",
  "Status": "Status",
  "Result": "Hasil",
  "When": "Waktu",

  // Login
  "Sign-in failed": "Gagal masuk",
  "Sign in to continue": "Masuk untuk melanjutkan",
  "Retry": "Coba lagi",
  "Server unreachable: {message}": "Server tidak dapat dihubungi: {message}",
  "Username": "Nama pengguna",
  "Password": "Kata sandi",
  "Sign in": "Masuk",

  // Settings: groups
  "Storage": "Penyimpanan",
  "Files are kept on the server only temporarily. Download the ZIP to keep a restored site.": "File hanya disimpan sementara di server. Unduh ZIP untuk menyimpan situs yang dipulihkan.",
  "Keep files after a recovery": "Simpan file setelah pemulihan",
  "Then the job's files are deleted automatically. Results stay visible; Run again rebuilds them.": "Setelah itu file proses dihapus otomatis. Hasil tetap terlihat; Jalankan lagi akan membuatnya ulang.",
  "hours": "jam",
  "Largest file to download": "Ukuran file maksimum yang diunduh",
  "MB": "MB",
  "Disk limit per recovery": "Batas disk per pemulihan",
  "0 = no limit. The job pauses when it is reached.": "0 = tanpa batas. Proses dijeda saat batas tercapai.",
  "GB": "GB",
  "What gets restored.": "Apa saja yang dipulihkan.",
  "Keep older website versions separately": "Simpan versi lama website secara terpisah",
  "Leave out spam pages": "Lewati halaman spam",
  "Gambling, adult and pharma pages injected while the domain was abused are not restored (listed in the report).": "Halaman judi, dewasa, dan obat yang disisipkan saat domain disalahgunakan tidak dipulihkan (tercantum di laporan).",
  "Recover website-builder files automatically": "Pulihkan file website builder secara otomatis",
  "GoDaddy (wsimg), Wix, Squarespace, Shopify, Webflow, Weebly, Google Fonts… archived copies only.": "GoDaddy (wsimg), Wix, Squarespace, Shopify, Webflow, Weebly, Google Fonts… hanya salinan arsip.",
  "Recover files hosted on other sites (CDNs)": "Pulihkan file yang di-host di situs lain (CDN)",
  "Uses archived copies, never live files.": "Memakai salinan arsip, tidak pernah file live.",
  "Only these other sites": "Hanya situs lain berikut",
  "Comma separated. Empty = any site.": "Pisahkan dengan koma. Kosong = semua situs.",
  "Allow newer image/CSS captures": "Izinkan rekaman arsip gambar/CSS yang lebih baru",
  "Only when no older copy exists; always reported. Pages are never replaced by newer captures.": "Hanya jika tidak ada salinan yang lebih lama; selalu dilaporkan. Halaman tidak pernah diganti dengan rekaman arsip yang lebih baru.",
  "days": "hari",
  "Download audio and video": "Unduh audio dan video",
  "Disable contact forms": "Nonaktifkan formulir kontak",
  "Forms need the original server and cannot work in a static copy.": "Formulir butuh server asli dan tidak bisa berfungsi di salinan statis.",
  "Archive access": "Akses arsip",
  "How politely the Internet Archive is contacted. Lower values are slower but safer.": "Seberapa sopan Internet Archive dihubungi. Nilai lebih rendah lebih lambat tetapi lebih aman.",
  "Starting speed": "Kecepatan awal",
  "Requests per second, shared by all running jobs.": "Permintaan per detik, dibagi untuk semua proses yang berjalan.",
  "Speed up automatically": "Percepat otomatis",
  "Goes faster while the archive responds well and slows down immediately when it is busy.": "Makin cepat selama arsip merespons baik dan langsung melambat saat arsip sibuk.",
  "Maximum speed": "Kecepatan maksimum",
  "Upper limit for the automatic speed-up.": "Batas atas untuk percepatan otomatis.",
  "Parallel downloads per job": "Unduhan paralel per proses",
  "Retries per file": "Percobaan ulang per file",
  "Request timeout": "Batas waktu permintaan",
  "s": "dtk",
  "Advanced": "Lanjutan",
  "Fine-tuning. The defaults work for most domains.": "Penyesuaian detail. Nilai bawaan cocok untuk sebagian besar domain.",
  "Website-version split sensitivity": "Sensitivitas pemisahan versi website",
  "Lower = fewer, larger versions.": "Lebih rendah = versi lebih sedikit dan lebih besar.",
  "Archive gap that starts a new version": "Jeda arsip yang memulai versi baru",
  "years": "tahun",
  "Follow CSS references": "Ikuti referensi CSS",
  "levels": "tingkat",
  "Also use Common Crawl when analyzing": "Gunakan juga Common Crawl saat analisis",
  "Run scripts in the preview (sandboxed)": "Jalankan skrip di pratinjau (sandbox)",

  // Settings: page
  "Settings saved": "Pengaturan disimpan",
  "Password changed": "Kata sandi diubah",
  "Settings": "Pengaturan",
  "Defaults for all domains. Individual domains can override them in Domain settings.": "Nilai bawaan untuk semua domain. Tiap domain bisa menimpanya di Pengaturan domain.",
  "Account": "Akun",
  "Change the administrator password.": "Ubah kata sandi administrator.",
  "Current password": "Kata sandi saat ini",
  "New password (10+ characters)": "Kata sandi baru (min. 10 karakter)",
  "New password": "Kata sandi baru",
  "Change password": "Ubah kata sandi",
  "System information": "Informasi sistem",
  "You have unsaved changes.": "Ada perubahan yang belum disimpan.",
  "Discard": "Buang",
  "Save changes": "Simpan perubahan",

  // Batch detail
  "No finished recoveries to bundle yet": "Belum ada pemulihan selesai untuk digabungkan",
  "Domains": "Domain",
  "Analyzed and recovered automatically": "Dianalisis dan dipulihkan otomatis",
  "Analysis only": "Hanya analisis",
  "recommended period": "periode yang disarankan",
  "Report CSV": "Laporan CSV",
  "All ZIPs": "Semua ZIP",
  "Recovered": "Sudah dipulihkan",
  "{n} pages": "{n} halaman",

  // URL explorer
  "Archived URLs": "URL yang diarsipkan",
  "Every address the Internet Archive captured for this domain. Click a row to see all its captures.": "Semua alamat yang direkam Internet Archive untuk domain ini. Klik baris untuk melihat semua rekaman arsipnya.",
  "Search URL": "Cari URL",
  "Type": "Jenis",
  "Pages and files": "Halaman dan file",
  "Pages": "Halaman",
  "Files": "File",
  "Year": "Tahun",
  "All years": "Semua tahun",
  "Never captured successfully": "Tidak pernah terekam dengan baik",
  "No URLs match.": "Tidak ada URL yang cocok.",
  "Page": "Halaman",
  "{n} captures": "{n} rekaman arsip",
  "{n} version": "{n} versi",
  "{n} versions": "{n} versi",
  "Capture history": "Riwayat rekaman arsip",
  "Show a screenshot of this capture": "Tampilkan screenshot rekaman arsip ini",
  "View": "Lihat",
  "Open in the Wayback Machine": "Buka di Wayback Machine",

  // Add domains
  "{name} added — analysis started": "{name} ditambahkan — analisis dimulai",
  "{name} is already in your list": "{name} sudah ada di daftar",
  "{n} domain added": "{n} domain ditambahkan",
  "{n} domains added": "{n} domain ditambahkan",
  "Add domains": "Tambah domain",
  "Enter one domain or paste a list. Each domain is analyzed automatically.": "Masukkan satu domain atau tempel daftar. Setiap domain dianalisis otomatis.",
  "View batch progress": "Lihat progres batch",
  "Done": "Selesai",
  "Cancel": "Batalkan",
  "Adding…": "Menambahkan…",
  "Add {n} domains": "Tambah {n} domain",
  "Add domain": "Tambah domain",
  "added": "ditambahkan",
  "already in your list": "sudah ada di daftar",
  "analyses started": "analisis dimulai",
  "recovery starts automatically after each analysis": "pemulihan dimulai otomatis setelah setiap analisis",
  "Skipped": "Dilewati",
  "{n} domain": "{n} domain",
  "{n} domains": "{n} domain",
  "One per line — URLs are fine too": "Satu per baris — URL juga boleh",
  "Import CSV/TXT": "Impor CSV/TXT",
  "Recover automatically": "Pulihkan otomatis",
  "After analysis, restore each domain from its recommended period. You can always recover manually instead.": "Setelah analisis, pulihkan setiap domain dari periode yang disarankan. Pemulihan manual tetap bisa dilakukan.",

  // Snapshot screenshot
  "Open this capture in the Wayback Machine": "Buka rekaman arsip ini di Wayback Machine",
  "Archived page {path} on {ts}": "Halaman arsip {path} pada {ts}",
  "Screenshot unavailable": "Screenshot tidak tersedia",
  "Taking screenshot from the archive…": "Mengambil screenshot dari arsip…",

  // Error boundary
  "This section failed to render.": "Bagian ini gagal ditampilkan.",
  "Try again": "Coba lagi",
  "Something went wrong": "Terjadi kesalahan",
  "The dashboard hit an unexpected error. Your recovery jobs keep running on the server.": "Dashboard mengalami kesalahan tak terduga. Proses pemulihan tetap berjalan di server.",
  "Reload": "Muat ulang",
  "Try to continue": "Coba lanjutkan",

  // Overlay
  "More actions": "Aksi lainnya",
  "Close": "Tutup",
} as Record<string, string>;
